import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from 'react-bootstrap';
import { useQueryClient } from 'react-query';
import DatePicker from '../../components/forms/formDatePicker';

const FilterIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
    </svg>
);
const ChevIcon = () => (
    <svg className="ic chev" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="6 9 12 15 18 9" />
    </svg>
);

const NotificationsFilter = ({ isFiltering, onFilter }) => {
    const { t } = useTranslation();

    const [isShow, setIsShow] = useState(false)
    const [dateFrom, setDateFrom] = useState('')
    const [dateTo, setDateTo] = useState('')
    const queryClient = useQueryClient()

    const activeCount = [dateFrom, dateTo].filter(Boolean).length

    const handleFilter = (e) => {
        e.preventDefault()
        e.stopPropagation()
        onFilter([
            dateFrom ? new Date(dateFrom.setHours(0, 0, 0, 0)) : '',
            dateTo ? new Date(dateTo.setHours(23, 59, 59, 999)) : '',
        ])
    }

    const handleReset = () => {
        onFilter(['', ''])
        setDateFrom('')
        setDateTo('')
        queryClient.invalidateQueries(['notifications'])
    }

    return (
        <>
            <button type="button" className={`filter-toggle${isShow ? ' on' : ''}`} onClick={() => setIsShow(s => !s)}>
                <FilterIcon /> {t('notificationsPage.filters')}
                {activeCount > 0 && <span className="cnt">{activeCount}</span>}
                <ChevIcon />
            </button>

            {isShow && (
                <Form onSubmit={handleFilter} className="filter-panel">
                    <div className="filter-grid">
                        <DatePicker className="form-control" label={t('notificationsPage.dateFrom')} placeholderText={t('notificationsPage.filterDateFrom')}
                            selected={dateFrom} onChange={setDateFrom} maxDate={dateTo || undefined} dateFormat="dd.MM.yyyy" />
                        <DatePicker className="form-control" label={t('notificationsPage.dateTo')} placeholderText={t('notificationsPage.filterDateTo')}
                            selected={dateTo} onChange={setDateTo} minDate={dateFrom || undefined} dateFormat="dd.MM.yyyy" />
                    </div>

                    <div className="filter-foot">
                        <span className="meta">
                            {activeCount > 0 ? t('notificationsPage.filtersSelected', { count: activeCount }) : t('notificationsPage.noFiltersApplied')}
                        </span>
                        <div className="sp">
                            <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={handleReset}>{t('notificationsPage.reset')}</button>
                            <button type="submit" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isFiltering}>
                                {isFiltering ? t('notificationsPage.filtering') : t('notificationsPage.applyFilters')}
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </>
    )
}

export default NotificationsFilter
